import React, { Component } from "react";
import * as Constants from "../../../common/Global/constants";
import { getLocalStorageVariables, isEmptyVariable, ifEmptyReturn, isEmptyArray, handleTokenExpiry } from "../../../common/Global/commonFunctions";
import { AddNewButtonLayout } from "../../../common/Global/globalStyles.style";
import AddCommentDialog from "./addcommentdialog";

import { Modal } from "react-bootstrap";
import moment from "moment";
let userDetails = getLocalStorageVariables();

class ReviewHistoryDialog extends Component {
	constructor(props) {
		super(props);
		this.state = {
			componentDidMountFlag: false,
			showLoader: false,
			datalist: [],
			selectedRemark:"",
			selectedAssignmentSampleCheckedRemarkId:"",
			isEdit:false,
            currentPageNo: 1
		};
		userDetails = getLocalStorageVariables();
	}

	componentDidMount() {}

	componentDidUpdate(prevProps) {
		if (JSON.stringify(prevProps) !== JSON.stringify(this.props) && this.props.showReviewCommentsDialog) {
			this.setState(
				{
					componentDidMountFlag: false,
					showLoader: false,
					datalist: [],
					// totalCount:0,
					currentPageNo: 1,
					showCreateDialog: false,
					selectedRemark:"",
					selectedAssignmentSampleCheckedRemarkId:"",
					isEdit:false
				},
				() => {
					this.getInitData();
				}
			);
		}
	}
	handleCreateDialogShow = () => {
		this.setState({
			showCreateDialog: true,

			selectedId: "",
		
		});
	};

	handleAddDialogClose = (reloadFlag) => {
		this.setState({
			showCreateDialog: false,
			selectedRemark:"",
			selectedAssignmentSampleCheckedRemarkId:"",
			isEdit:false
		},() => {
			if (reloadFlag === true) this.getInitData(true);
		});
	};

	handleEditDialogShow = (item) => {
		this.setState({
			showCreateDialog: true,
			isEdit:true,
			selectedAssignmentSampleCheckedRemarkId:item.assignmentSampleCheckedRemarkId,
			selectedRemark:item.remark,
		});
	};


	getInitData = (reloadFlag) => {
		this.setState({
			showLoader: true,
		});
		Promise.all([
			fetch(Constants.GetSampleCheckedRemarks, {
				method: "POST",
				mode: "cors",
				body: new URLSearchParams({
					email: userDetails.email,
					accessToken: userDetails.accessToken,
					assignmentSampleCheckedId: this.props.masterDataId,
					// pageNo:this.state.currentPageNo
				}),
			}),
			fetch(Constants.GetSampleCheckedAuditTrail, {
				method:"POST",
				mode:"cors",
				body: new URLSearchParams(
				{
					email:userDetails.email,
					accessToken:userDetails.accessToken,
					assignmentSampleCheckedId:this.props.masterDataId,
					pageNo:this.state.currentPageNo
				})
			})
		])
        .then(([sampleCheckedRemark, sampleCheckedReviewHistory]) => {
				return Promise.all([sampleCheckedRemark.json(),sampleCheckedReviewHistory.json()
        	]);
		})
		.then(([sampleCheckedRemark, sampleCheckedReviewHistory]) => {
			let sampleCheckedRemarkList = [];
			let reviewHistoryList = [];
			if(handleTokenExpiry(sampleCheckedRemark.responseCode)) return;
			else if (sampleCheckedRemark.responseCode === Constants.CODE_SUCCESS) {
				sampleCheckedRemarkList = sampleCheckedRemark.data.remarks;
			} else {
			}

			if(handleTokenExpiry(sampleCheckedReviewHistory.responseCode)) return;
			else if (sampleCheckedReviewHistory.responseCode === Constants.CODE_SUCCESS) {
				reviewHistoryList = sampleCheckedReviewHistory.data.auditTrail
			} else {
			}

			const mergedList = [
				...((sampleCheckedRemarkList || []).map(item => ({
					...item,
					type: 'remark'
				}))),
				...((reviewHistoryList || []).map(item => ({
					...item,
					type: 'history'
				})))
			].sort((a, b) => new Date(b.createDate) - new Date(a.createDate));

			this.setState({
				datalist: mergedList,
				showLoader: false,
				componentDidMountFlag: true,
			}, () => {
				if(reloadFlag === true){
					this.props.handleReviewCommentsDialogClose(true);
				}
			});
		});
	};

	render() {
		// Find the item with the latest lastUpdateDate (or createDate if lastUpdateDate is null)
		const latestItem = !isEmptyArray(this.state.datalist)
			? this.state.datalist.reduce((latest, item) => {
				const latestDate = latest.lastUpdateDate || latest.createDate;
				const itemDate = item.lastUpdateDate || item.createDate;
				return new Date(itemDate) > new Date(latestDate) ? item : latest;
			}, this.state.datalist[0])
		: null;
		return (
			<Modal className="review-history-dialog custom-dialog" show={this.props.showReviewCommentsDialog} backdrop="static">
				<Modal.Header>
					<h5>Review Comments</h5>
					<button onClick={this.props.handleReviewCommentsDialogClose} type="button" data-dismiss="modal">
						<span class="material-icons">close</span>
					</button>
				</Modal.Header>
				<hr />
				<div className="modal-body">
					{this.state.showLoader && (
						<div class="loader"></div>
					)}
					<div className="review-history-wrapper">
						<div className="search-addnew-bg">
							<div className="search-addnew">
								<div></div>
								<AddNewButtonLayout themeSettings={this.props.themeSettings}>
									<a onClick={this.handleCreateDialogShow} href="javascript:void(0);">
										<span className="material-icons">add_circle</span>
										<p>Add New</p>
									</a>
								</AddNewButtonLayout>
							</div>
						</div>
						{this.state.componentDidMountFlag && (
							<div className="review-history-list">
								{!isEmptyArray(this.state.datalist) &&
									this.state.datalist.map((item, idx) => {
										if (item.type === 'remark') {
											const isLatest = latestItem && item.userId == userDetails.userId && item.assignmentSampleCheckedRemarkId === latestItem.assignmentSampleCheckedRemarkId;
											return (
												<div className="history-item-layout" key={`remark-${item.assignmentSampleCheckedRemarkId}`}>
													<div className="flex-center-layout just-space-between">
														<p className="font-bold">{item.remark}</p>
														{
															isLatest && this.props.isDraftOnward !== true &&
															<div onClick = {this.handleEditDialogShow.bind(this,item)} className="history-span">
																<span className="material-icons">edit</span>
															</div>
														}
													</div>
													<p>
														{" "}
														{ifEmptyReturn(item.salutation) + " " + item.firstName + " " + ifEmptyReturn(item.middleName) + " " + item.lastName} (
														{item.createBy})
													</p>
													<span className="review-history-date-span">
														{moment(item.createDate, "YYYY-MM-DDTHH:mm:ss.SSSZ").format("DD-MMM-YYYY hh:mm a")}
													</span>
												</div>
											);
										} else if (item.type === 'history') {
											let column = "";
											if(item.column === "notReceived"){
												column = "Not Received";
											}else if(item.column === "verified"){
												column = "Verified";
											}else if(item.column === "received"){
												column = "Received";
											}else if(item.column === "partReceived"){
												column = "Partly Received";
											}
											return (
												<div className="history-item-layout" key={`history-${item.assignmentSampleCheckedId}-${item.column}-${item.createDate}`}>
													<p className="font-bold">{column}</p>
													<p className="review-history-remarks">
														<strong> </strong>
														{`Checked ${column} by`} {ifEmptyReturn(item.salutation) + " " + item.firstName + " " + ifEmptyReturn(item.middleName) + " " + item.lastName} 
														{/* {(isEmptyVariable(item.oldValue) ? "empty" : item.oldValue) + " -> " + item.newValue} */}
														{/* {(isEmptyVariable(item.oldValue) ? "Checked Partly Received by " + 
															ifEmptyReturn(item.salutation) + " " + item.firstName + " " + ifEmptyReturn(item.middleName) + " " + item.lastName : 
															"Checked Received by " +
															ifEmptyReturn(item.salutation) + " " + item.firstName + " " + ifEmptyReturn(item.middleName) + " " + item.lastName)} */}
													</p>
													{/* <span>
														{ifEmptyReturn(item.salutation) + " " + item.firstName + " " + ifEmptyReturn(item.middleName) + " " + item.lastName}
													</span> */}
													<span className="review-history-date-span">
														{moment(item.createDate, "YYYY-MM-DDTHH:mm:ss.SSSZ").format("DD-MMM-YYYY hh:mm a")}
													</span>
												</div>
											);
										}
									})}
							</div>
						)}
						{this.state.componentDidMountFlag && isEmptyArray(this.state.datalist) && (
							<div className="dialog-no-records">
								<p>{Constants.NO_RECORDS_WARNING}</p>
							</div>
						)}
					</div>
				</div>
				<AddCommentDialog
					showCreateDialog={this.state.showCreateDialog}
					handleAddDialogClose={this.handleAddDialogClose}
                    assignmentSampleCheckedId= {this.props.masterDataId}
                    themeSettings={this.props.themeSettings}
					selectedRemark={this.state.selectedRemark}
					isEdit={this.state.isEdit}
					selectedAssignmentSampleCheckedRemarkId={this.state.selectedAssignmentSampleCheckedRemarkId}
				/>
			</Modal>
		);
	}
}

export default ReviewHistoryDialog;
